class ImageUtils {
    // static isImageData (image) {
    //     const type = [
    //         'HTMLImageElement',
    //         'SVGImageElement',
    //         'HTMLVideoElement',
    //         'HTMLCanvasElement',
    //         'VideoFrame'
    //         // 'OffscreenCanvas',
    //         // 'ImageBitmap',
    //         // 'Blob',
    //         // 'ImageData',
    //     ].find(type => {
    //         if(!globalThis[type]) return;
    //         if(image instanceof globalThis[type]){
    //             return true;
    //         }
    //     })
    //     if(type){
    //         return type;
    //     }
    // }

    static getSize (image) {
        if(image.width && image.height){
            return {
                width: image.width,
                height: image.height
            }
        }if(globalThis.HTMLVideoElement && image instanceof globalThis.HTMLVideoElement){
            return {
                width: image.videoWidth,
                height: image.videoHeight,
            }
        }else if(globalThis.VideoFrame && image instanceof globalThis.VideoFrame){
            return {
                width: image.displayWidth,
                height: image.displayHeight,
            }
        }
    }

    static async createImageData ({image, transImageSize}) {
        let imageBitmap = image;
        const canvas = (() => {
            if(globalThis.OffscreenCanvas){
                return new OffscreenCanvas(1, 1);
            }
            return globalThis.document?.createElement('canvas');
        })();
        const ctx = canvas.getContext('2d');

        let {width, height} = this.getSize(imageBitmap);

        let scale = 1;
        if(transImageSize !== undefined){
            if(width > transImageSize || height > transImageSize){
                scale = Math.max(
                    transImageSize / width,
                    transImageSize / height
                );
            }
        }

        if(scale !== 1){
            width = Math.floor(width * scale);
            height = Math.floor(height * scale);
        }
        canvas.width = width;
        canvas.height = height;

        ctx.drawImage(imageBitmap, 0, 0, canvas.width, canvas.height);

        // pixel data (RGBA)
        const data = ctx.getImageData(0, 0, canvas.width, canvas.height);
        return {
            canvas, ctx,
            data
        }
    }

    static async getImageAlphaPixelCount ({
      image, transImageSize, allowedPixelPercent,
      availAlphaCount
    }) {
        // pixel data (RGBA)
        const imageDataObj = await this.createImageData({image, transImageSize});
        const imageData = imageDataObj.data;
        const pixels = imageData.data; // Uint8ClampedArray (RGBA)

        const totalPixels = pixels.length / 4; // RGBA
        let allowedPixelCount = totalPixels;
        if(!isNaN(allowedPixelPercent) && allowedPixelPercent > 0){
            if(allowedPixelPercent > 1){
                allowedPixelPercent /= 100;
            }
            allowedPixelCount = Math.min(totalPixels, totalPixels * allowedPixelPercent);
        }

        let findPixels = 0;
        for (let i = 0; i < pixels.length; i += 4) {
            const alpha = pixels[i + 3]; // Alpha 값 (0~255)
            if (alpha > availAlphaCount) findPixels++;
            if(findPixels > allowedPixelCount) break;
        }

        return {
            findPixels, totalPixels,
            rate: findPixels / totalPixels,
        }
    }
}

export {
    ImageUtils
 }